import Vue from 'vue'

Vue.prototype.$bus = new Vue()
